import Api from '@teko/api';
import { accessTokenInterceptor, handleResponseUnauthorizedInterceptor } from '@teko/auth';
import { requestDurationTrackingInterceptor, responseDurationTrackingInterceptor } from '@teko/tracking';
import { cleanObject } from '@teko/utils';
import { isServerless } from './helpers.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const DEFAULT_SEARCH_DATA = {
  page: 0,
  pageSize: 0,
  total: 0
};
class DiscoveryService {
  constructor(discoveryApiUrl, terminalId, language, location) {
    this.location = location;
    this.discoveryApi = new Api(discoveryApiUrl);
    this.terminalId = terminalId;
    this.discoveryApi.addInterceptor(accessTokenInterceptor);
    this.discoveryApi.addInterceptor((request) => {
      request.headers.set("Accept-Language", language || "*");
    });
    !!isServerless() && this.discoveryApi.addInterceptor(requestDurationTrackingInterceptor);
    !!isServerless() && this.discoveryApi.addResponseInterceptor(responseDurationTrackingInterceptor);
    this.discoveryApi.addResponseInterceptor(handleResponseUnauthorizedInterceptor);
  }
  getTerminalId() {
    return this.terminalId;
  }
  get baseParams() {
    return cleanObject({
      terminalId: this.terminalId,
      location: this.location
    });
  }
  async search(payload, searchAlgoHeaderValue) {
    const { data } = await this.discoveryApi.post("/search-skus-v2", __spreadValues(__spreadValues({}, this.baseParams), payload), {
      headers: !!searchAlgoHeaderValue ? {
        "X-Enable-Search-Algorithm": searchAlgoHeaderValue
      } : {}
    });
    return (data == null ? void 0 : data.data) || DEFAULT_SEARCH_DATA;
  }
}

export { DiscoveryService };
